import {action, observable} from "mobx"
import _ from "lodash"

export default class DownloadStore {

  constructor(api) {
    this.api = api
  }

  @observable downloadsByProductId = new Map()

  @action fetch(folder = "web", id) {
    return fetch( `${this.api.config.BASE}shop/fileserver/files/${folder}/${id}`, {
      method:      "GET",
      credentials: "include",
      headers:     {
        "Accept":       "application/json",
        "Content-Type": "application/json"
      }
    } )
      .then( res => res.json() )
      .then( res => res.files )
      .then( files => {
        let downloads = this.downloadsByProductId.get( id ) || []
        files.forEach( file => {
          file.folder = folder
          let exists  = _.find( downloads, f => f.url === file.url )
          if ( !exists ) downloads.push( file )
        } )
        this.downloadsByProductId.set( id, downloads )
      } )
  }
}




// WEBPACK FOOTER //
// ./src/theme/oehme/shop/DownloadStore.js